// eslint-disable-next-line no-shadow
export enum AppEnvironment {
	PROD = 'prod',
	DEV = 'dev',
	RC = 'rc',
	LOCAL = 'local',
	EXT_TEST = 'ext-test'
}
